import { render, staticRenderFns } from "./centerindex.vue?vue&type=template&id=735ccbec&scoped=true"
import script from "./centerindex.vue?vue&type=script&lang=js"
export * from "./centerindex.vue?vue&type=script&lang=js"
import style0 from "./centerindex.vue?vue&type=style&index=0&id=735ccbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ccbec",
  null
  
)

export default component.exports